import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isRelativeUrl = !/^(http|https)/.test(req.url);

    const isApiRequest = req.url.startsWith('/api') || req.url.startsWith('api/');

    if (isRelativeUrl && isApiRequest) {
      const normalizedPath = req.url.startsWith('/') ? req.url : `/${req.url}`;
      const url = `${environment.backendUrl}${normalizedPath}`;
      const clonedReq = req.clone({ url });
      return next.handle(clonedReq);
    }
    return next.handle(req);
  }
}
